export default {
  init() {
    jQuery((function () {

      // JavaScript to be fired on all pages

      var searchUI = jQuery('#search-ui');

      jQuery('.header-search-btn').on('click', function (e) {
        searchUI.toggleClass('show');
        e.preventDefault();
      });

      jQuery('.search-bar-overlay').on('click', function () {
        searchUI.removeClass('show');
      });

      jQuery('.scroll-to-top').on('click', function () {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });

      //
      // Responsive resize for videos embedded from youtube in the Classic Editor
      //
      function resizeAllVideos() {
        jQuery('iframe[src*="youtube"]').not('.wp-block-embed iframe').each(function () {
          resizeVideoEmbed(this);
          console.log('its happening');
        });
      }

      function resizeVideoEmbed(el) {
        var newHeight = jQuery(el).width() * 0.5625;
        jQuery(el).height(newHeight);
      }

      setTimeout(resizeAllVideos, 500);

      jQuery(window).on('resize', function () {
        resizeAllVideos();
      })

    }))
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js